import { InjectionToken } from '@angular/core';
import { PortalType } from '@ats/api/cm';

export interface CultureServiceConfig {
	api: string;
	portal: PortalType;
}

export const CULTURE_SERVICE_CONFIG = new InjectionToken<CultureServiceConfig>(
	'Culture Service Configuration'
);

export interface Culture {
	code: string;
	label: string;
	nativeLabel: string;
}

export interface ClientCultureAPIResponse {
	[key: string]: {
		label: string;
		nativeLabel: string;
		ietfBcp47Name: string;
		windows3CharName: string;
		iso3CharName: string;
	};
}
